<template>
  <loading v-model:active="isLoading"
           :can-cancel="false"
           :on-cancel="onCancel"
           :is-full-page="fullPage"/>
  <div  v-if="!isLoading" class="products">
    <h5  v-if="products.data.length > 0">جدیدترین محصولات - {{category_name}}</h5>
    <h5  v-else>محصولی در این دسته بندی وجود ندارد</h5>
    <div class="col-6 float-right cat" v-for="(product, index)  in products.data" :key="index" >
      <div  v-if="product.pic!=''" class="catItem">
        <img :src="product.img_url" width="100%" height="auto"/>
        <h3 v-text="product.title"></h3>
        <v-divider class="divider"/>
        <h4> هر {{ product.uint_title }}  : {{ product.price_format }} ریال</h4>
        <v-dialog max-width="500" transition="dialog-bottom-transition">
          <template v-slot:activator="{ props: activatorProps }">
            <v-btn
                v-bind="activatorProps"
                color="surface-variant"
                text="افزودن به سبد خرید"
                variant="flat"
            ></v-btn>
          </template>

          <template v-slot:default="{ isActive }">
            <v-card style="direction: rtl" :title="'افزودن به سبد خرید محصول '+product.title">
              <v-divider/>
              <v-card-text>
                <div class="form-group">
                  <div class="col-sm-12">
                    <label class="label col-3 float-right">
                      متراژ :
                    </label>
                    <input id="mobile-field" style="direction: ltr !important;" required v-model="product.val" type="text" class="form-control text-center col-9 float-end metraz" name="mobile" placeholder="متراژ را وارد کنید" @keyup="setprice(product)">
                    <label class="label " style="margin: 15px auto">
                      قیمت کل : {{product.showprice}} ریال
                    </label>
                    <div class="btn btn-success" style="text-align: center" @click="addtoBasket(product);isActive.value = false">
                      افزودن به سبد خرید
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </template>
        </v-dialog>
      </div>

    </div>

    <div class="clearfix"></div>
  </div>

</template>

<script>
import http from "@/plugins/axios";
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

// Import Swiper styles
import 'swiper/css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
var numeral = require("numeral");
export default {
  components: {
    Loading,
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  name: 'products',
  data: () =>({
    formatLang: 'fa-IR',
    formatStyle: 'currency',
    formatCurrency: 'ریال',
    isLoading: true,
    fullPage: true,
    products :  {
      data: [],
    },
  }),
  methods: {
    addtoBasket(product){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/basket/add",{
        product_id : product.id,
        val : product.val,
      }, { headers: { Authorization: AuthStr ,"Content-type": "multipart/form-data"} })
          .then(response => {
            this.isLoading = false;
            this.$toast.success("محصول با موفقیت به سبد خرید اضافه شد.", {

              theme: "toasted-primary",
              position: "top-right",
              duration : 5000,

            });
          })
          .catch((error) => {

          });
    },
    setprice(product){
      let price =0;
      product.showprice =  numeral(product.val*product.price).format("0,0");
      return product;
    },
    getPicLink() {
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/productsCategory/"+this.category, { headers: { Authorization: AuthStr } })
          .then(response => {
            this.products = response.data;
            this.isLoading = false;
          })
          .catch((error) => {

          });
    },
  },
  mounted() {
    this.getPicLink();
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  props: [
    "category",
    "category_name"
  ],
}
</script>

<style scoped>
button.v-btn{
  width: 100%;
  border-radius: 0;
}
h5{
  text-align: center;
  margin: 10px auto;
  width: 300px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  padding-top: 30px;
}
.metraz{
  direction: ltr !important;
  width: 70%;
  margin-top: -8px;
}
.divider{
  margin: 5px 10px;
}
.catItem{
  width: 90%;background: #e7e7e7;border-radius: 10px;
  overflow: hidden;
  font-family: iranyekan !important;
}
h2{
  text-align: center;
  margin: 10px auto;
  width: 200px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  font-family: iranyekan !important;

}
h4{
  text-align: center;
  font-size: 12px;
}
h3{
  text-align: center;
  padding: 10px 0 0;
  font-family: iranyekan !important;

}
.cat:hover h3{
  display: block;
}
.cat:hover img{
  opacity: 0.5;
}
.cat img{
  margin: 0 auto;
}
.cat{
  margin: auto -5px;
  padding: 5px;
  position: relative;
}
.products{
  margin-bottom: 100px;
}
</style>